.stepper-card {
  display: flex;
  flex-flow: column wrap;
  gap: var(--mantine-spacing-md);
}

.slide {
  display: flex;
  flex: 0 1 auto;
  flex-flow: column wrap;
  gap: var(--mantine-spacing-sm);
}

.slide-actions {
  display: flex;
  &:empty {
    display: none;
  }
}

.question {
  font-size: var(--mantine-font-size-lg);
}

.options {
  display: flex;
  flex: 0 1 auto;
  flex-flow: row wrap;
  gap: var(--mantine-spacing-sm);
}

.option-content {
  display: flex;
  flex: 0 1 auto;
  flex-flow: column wrap;
  gap: var(--mantine-spacing-xs);
  margin: var(--mantine-spacing-sm);
}

.option-label {
  font-size: var(--mantine-font-size-md);
  font-weight: calc(var(--mantine-heading-font-weight) * 0.714);
}

.option-description {
  font-size: var(--mantine-font-size-sm);
  font-weight: 400;
  color: var(--mantine-color-dark-accent-2);
}

.checkbox-group {
  display: inline-flex;
  flex-flow: row wrap;
  gap: var(--mantine-spacing-md);
  & > div {
    display: contents;
  }
}

.checkbox-card {
  flex: 0 1 fit-content;
  &[data-checked] {
    background: var(--mantine-color-dark-accent-8);
  }
}

.checkbox-content {
  display: grid;
  grid-template:
    'indicator label' min-content
    'indicator description' min-content / min-content auto;
  column-gap: var(--mantine-spacing-xs);
  /* align-content: baseline; */
  padding: var(--mantine-spacing-sm);
}

.checkbox-indicator {
  display: flex;
  grid-area: indicator;
  place-items: center;
}

.checkbox-label {
  grid-area: label;
  font-size: var(--mantine-font-size-lg);
  font-weight: calc(var(--mantine-heading-font-weight) * 0.857);
}

.checkbox-description {
  grid-area: description;
}
